import React from 'react'
import { styled } from '@mui/material/styles';
import { Backdrop, CircularProgress } from '@mui/material'
import { useAppSelector } from 'Stores/Hooks/hooks';
import { RootState } from 'Stores/store';

const PREFIX = 'ProgressCircular';

const classes = {
  backdrop: `${PREFIX}-backdrop`
};

const StyledBackdrop = styled(Backdrop)((
  {
    theme
  }
) => ({
  [`&.${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

function ProgressCircular() {
  const progressState = useAppSelector((state: RootState) => state.progress)
  const { loading } = progressState

  return (
    <StyledBackdrop className={classes.backdrop} open={loading}>
      <CircularProgress color="inherit" />
    </StyledBackdrop>
  );
}

export default ProgressCircular
